(function () {
  function initialiseNews(root) {
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-news-filter]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-news-card]'));
    var empty = root.querySelector('[data-news-empty]');
    var count = root.querySelector('[data-news-count]');
    var reset = root.querySelector('[data-news-reset]');

    if (!buttons.length || !cards.length) return;

    function filterCards(filter) {
      var visible = 0;

      buttons.forEach(function (button) {
        var active = button.getAttribute('data-news-filter') === filter;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      cards.forEach(function (card) {
        var show = filter === 'all' || card.getAttribute('data-topic') === filter;
        card.hidden = !show;
        if (show) visible += 1;
      });

      if (empty) empty.hidden = visible !== 0;
      if (count) count.textContent = filter === 'all' ? count.getAttribute('data-news-total') : visible;
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        filterCards(button.getAttribute('data-news-filter'));
      });
    });

    if (reset) {
      reset.addEventListener('click', function () {
        filterCards('all');
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-obp-news]').forEach(initialiseNews);
  });
})();
